import { navData as incheonNav } from './incheon';
import { navData as michuholNav } from './michuhol';

export const navData = (() => {
  if (import.meta.env.VITE_STATE_NAME === 'mch') return michuholNav;
  return incheonNav;
})();
